module.exports = __webpack_public_path__ + "img/3_6.e067cdf2.png";